import { StyledBundlePrice, StyledBundlePriceButton } from './style';
import { ActualPrice } from './ActualPrice';
import { BundlePriceProps } from 'utils/types';
import { AutoTextSize } from 'utils/autoTextSizeUtils';
import React from 'react';
import {
  EBundlesInternalViewModel,
  ESpecialOfferInternalViewModel,
} from 'utils/enums';

const design: Record<string, any> = {
  match: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  candivore: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  communix: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  communix2: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  bagelcode: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  bagelcode2: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  me2on: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  locobingo: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  hug: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  ghost: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  ak: {
    width: {
      small: '90px',
      normal: '160px',
    },
  },
  mainSub: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  baba: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  playSimple: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  pipa: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  deca: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  [EBundlesInternalViewModel.BINGO_POP]: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  [EBundlesInternalViewModel.FABEL_TOWN]: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  [EBundlesInternalViewModel.LOAD_COMPLETE]: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  [EBundlesInternalViewModel.SPIN_X]: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  [EBundlesInternalViewModel.CASH_FRENZY]: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  gennmu: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
  [ESpecialOfferInternalViewModel.BANDITOS]: {
    width: {
      small: '100%',
      normal: '100%',
    },
  },
};

export const BundlePrice: React.FC<
  BundlePriceProps & { style?: React.CSSProperties }
> = ({
  whiteStripe,
  height,
  textShadow,
  borderRadius,
  type = 'ak',
  prices,
  availabilityText = 'Availability',
  availability = undefined,
  buttonText = 'FREE',
  isFree = false,
  width,
  timer,
  isTextAutoResized = false,
  style,
  onClick,
  buttonSuffixImage = '',
  buttonSuffixAnimation = '',
}) => {
  return (
    <StyledBundlePriceButton
      height={height}
      width={width ?? design[type]?.width.normal}
      borderRadius={borderRadius}
      className="price"
      style={style}
      onClick={onClick}
    >
      {whiteStripe && <div className="white_stripe"></div>}
      <StyledBundlePrice textShadow={textShadow}>
        <div className="totalPrice">
          {timer && <span className="timeLeft">Ends in {timer}</span>}
          {isFree ? (
            isTextAutoResized ? (
              <AutoTextSize
                mode="oneline"
                maxFontSizePx={16}
                minFontSizePx={4}
                flexGrow="1"
                style={{ textAlign: 'center' }}
              >
                <span className="isFree">{buttonText}</span>
              </AutoTextSize>
            ) : (
              <span>{buttonText}</span>
            )
          ) : isTextAutoResized ? (
            <AutoTextSize
              mode="oneline"
              maxFontSizePx={16}
              minFontSizePx={4}
              flexGrow="1"
            >
              <ActualPrice
                buttonSuffixImage={buttonSuffixImage}
                buttonSuffixAnimation={buttonSuffixAnimation}
                prices={prices}
                textShadow={textShadow}
              />
            </AutoTextSize>
          ) : (
            <ActualPrice
              buttonSuffixImage={buttonSuffixImage}
              buttonSuffixAnimation={buttonSuffixAnimation}
              prices={prices}
              textShadow={textShadow}
            />
          )}
          {availabilityText && availability && (
            <span className="availability">
              {availabilityText} {availability.remaining} / {availability.total}
            </span>
          )}
        </div>
      </StyledBundlePrice>
    </StyledBundlePriceButton>
  );
};
